import config from '../../config';
import authService from '../auth/auth-service';
import ordemServicoServico from '../OrdemServico/ordem-servico-servico';

const _configAPIBiometria = config.configAPIBiometria();

// Pendência da validação facial de OS, só na aba atual: sobrevive à ida/volta do front de biometria.
export const ETAPA_FACIAL_OS_KEY = 'etapaFacialOSPendente';
export const ACAO_INICIO = 'INICIO';
export const ACAO_FIM = 'FIM';
// Geração de contra-senha: a API resolve a atividade pela NA e devolve o atividadeId no 428.
export const ACAO_CONTRA_SENHA = 'CONTRA_SENHA';
// O comprovante vale ~2 min na biometria; pendência mais velha que isto é descartada.
const VALIDADE_PENDENCIA_MS = 10 * 60 * 1000;

/**
 * Leva o técnico ao front de biometria para validar o rosto ANTES de iniciar/encerrar a OS.
 * O código da URL e o comprovante que volta valem só para esta NA e esta ação.
 * @param extra dados para concluir a ação na volta (ex.: payload do fechamento, estado da navegação)
 * @returns true se redirecionou; false se não foi possível abrir a validação
 */
export async function iniciarEtapaFacialOS({ acao, atividadeId, na, returnPath, extra = null }) {
  if (!_configAPIBiometria.URI_API) return false;
  try {
    const response = await fetch(`${_configAPIBiometria.URI_API}/api/portal/os-access`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': authService.headerAPITecnico().Authorization,
      },
      body: JSON.stringify({ activityId: atividadeId, serviceNumber: na, action: acao, returnPath }),
    });
    if (response.status !== 200) return false;
    const body = await response.json();
    if (!body.redirectUrl) return false;
    sessionStorage.setItem(ETAPA_FACIAL_OS_KEY, JSON.stringify({ acao, atividadeId, na, extra, criadoEm: Date.now() }));
    window.location.assign(body.redirectUrl);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
}

/**
 * Volta do front de biometria com ?facial=<comprovante>. Só consome se a pendência for desta ação
 * (o ?facial= do login é tratado pela tela de login). Limpa a URL e a pendência: o comprovante é de uso único.
 * @returns null (nada pendente) | { expirado: true } | { codigo, pendente }
 */
export function consumirRetornoFacialOS(acao) {
  const codigo = new URLSearchParams(window.location.search).get('facial');
  const pendente = lerPendenciaComRetorno(acao);
  if (!pendente) return null;
  window.history.replaceState(window.history.state, '', window.location.pathname);
  sessionStorage.removeItem(ETAPA_FACIAL_OS_KEY);
  if (Date.now() - pendente.criadoEm > VALIDADE_PENDENCIA_MS) return { expirado: true };
  return { codigo, pendente };
}

/**
 * Olha, SEM consumir, a pendência desta ação na volta do front de biometria (?facial= na URL).
 * Serve para a tela preparar o que o componente precisa (ex.: a NA digitada); quem consome é só o componente.
 * @returns null | pendente ({ acao, atividadeId, na, extra, criadoEm })
 */
export function espiarRetornoFacialOS(acao) {
  return lerPendenciaComRetorno(acao);
}

function lerPendenciaComRetorno(acao) {
  if (!new URLSearchParams(window.location.search).get('facial')) return null;
  let pendente = null;
  try { pendente = JSON.parse(sessionStorage.getItem(ETAPA_FACIAL_OS_KEY) || 'null'); } catch { pendente = null; }
  if (!pendente || pendente.acao !== acao) return null;
  return pendente;
}

/**
 * Inicia a NA: sem exigência segue direto; com exigência a API responde etapaFacial e o técnico vai validar o rosto.
 * @returns { status: 'iniciada' } | { status: 'validacao' } | { status: 'erro', mensagem }
 */
export async function iniciarNAComFacial({ atividadeId, na, codigoFacial = null }) {
  const resposta = await ordemServicoServico.iniciarAtividadeDeServico(atividadeId, codigoFacial);
  if (!resposta) return { status: 'erro', mensagem: 'A atividade já foi iniciada!' };
  if (resposta.etapaFacial) {
    // Comprovante recusado na volta (expirado, outra NA/ação): não entra em ciclo, o técnico tenta de novo.
    if (codigoFacial) return { status: 'erro', mensagem: resposta.mensagem || 'Validação facial inválida ou expirada. Tente iniciar novamente.' };
    const redirecionou = await iniciarEtapaFacialOS({ acao: ACAO_INICIO, atividadeId, na, returnPath: window.location.pathname });
    return redirecionou ? { status: 'validacao' }
      : { status: 'erro', mensagem: 'Não foi possível abrir a validação facial. Tente novamente em instantes.' };
  }
  if (resposta.erro) return { status: 'erro', mensagem: resposta.erro };
  return { status: 'iniciada' };
}
